import React from 'react';
import './styles.css';
import arrowRight from '../../images/arrowRight.svg';
import Dropdown from '../dropdown/dropdown';

const Pagination = ({ 
  currentPage = 1,
  totalPages = 10,
  totalResults = 100,
  resultsPerPage = 5,
  onPageChange = () => {},
  onResultsPerPageChange = () => {},
  onNextClick = () => {},
  hasResults = true
}) => {
  
  // Generate array of page numbers to display (max 10)
  const getPageNumbers = () => {
    const pages = [];
    let startPage, endPage;
    
    if (totalPages <= 10) {
      // If total pages is 10 or less, show all pages
      startPage = 1;
      endPage = totalPages;
    } else {
      // More than 10 pages total
      if (currentPage <= 5) {
        // Show 1-10 when current page is 5 or less
        startPage = 1;
        endPage = 10;
      } else if (currentPage > totalPages - 5) {
        // Show last 10 pages when near the end
        startPage = totalPages - 9;
        endPage = totalPages;
      } else {
        // Show 10 pages centered on current page
        startPage = currentPage - 5;
        endPage = currentPage + 4;
      }
    }
    
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    
    return pages;
  };

  const pageNumbers = getPageNumbers();

  const handlePageClick = (pageNumber) => {
    if (pageNumber !== currentPage) {
      onPageChange(pageNumber);
    }
  };

  const handleNextClick = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handleResultsPerPageChange = (e) => {
    onResultsPerPageChange(parseInt(e.target.value));
  };

  const resultsPerPageOptions = [
    { value: '5', label: '5' },
    { value: '10', label: '10' },
    { value: '20', label: '20' }
  ];

  return (
    <nav className="pagination-container" aria-label="Pagination">
      <div className="pagination-content">
        {/* Page Numbers */}
        <ul className="page-numbers">
          {pageNumbers.map((pageNumber) => (
            <li key={pageNumber}>
              <button
                className={`page-number ${pageNumber === currentPage ? 'current' : ''}`}
                onClick={() => handlePageClick(pageNumber)}
                aria-current={pageNumber === currentPage ? 'page' : undefined}
                aria-label={`${pageNumber === currentPage ? 'Current page, ' : ''}Page ${pageNumber}`}
              >
                {pageNumber === currentPage && <div className="current-page-bar"></div>}
                <span className="page-number-text">{pageNumber}</span>
              </button>
            </li>
          ))}
        </ul>

        {/* Next Link */}
        <button 
          className={`next-button ${currentPage >= totalPages ? 'disabled' : ''}`} 
          onClick={handleNextClick}
          disabled={currentPage >= totalPages}
          aria-label="Go to next page"
        >
          <span className="next-text">Next</span>
          <img src={arrowRight} alt="" className="next-arrow" />
        </button>

        {/* Results Per Page */}
        <div className="results-per-page">
          <span className="results-per-page-text">Results per page</span>
          <Dropdown
            className="results-per-page-dropdown"
            value={resultsPerPage.toString()}
            onChange={handleResultsPerPageChange}
            options={resultsPerPageOptions}
          />
        </div>
      </div>
    </nav>
  );
};

export default Pagination;